<template>
  <base-modal form :title="`New ${Naming.AssetType}`">
    <div class="columns">
      <div class="column">
        <text-input
          required
          placeholder="ex: Vehicle"
          :error="$root.errors.name"
          :value="assetType.name"
          @input="name">
          Name
        </text-input>
      </div>
      <div class="column is-narrow">
        <text-input
          :error="$root.errors.short_code"
          :value="assetType.short_code"
          @input="code">
          Short Code
        </text-input>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <data-selector
          :description="`Indicate the level of risk that ${Naming.Assets.toLowerCase()} of this type will carry.`"
          :error="$root.errors.risk_id"
          :items="riskLevelList"
          value-key="id"
          label-key="level"
          :value="assetType.risk_id"
          @input="risk">
          Risk Level
        </data-selector>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <data-selector
          multiple
          delete-buttons
          required
          searchable
          :description="`Select one or more ${Naming.Checklists.toLowerCase()} for this type. ${Naming.Technicians} will be able to choose one when performing an ${Naming.Inspection}.`"
          :error="$root.errors.checklists"
          :items="checklistList"
          value-key="id"
          label-key="name"
          :value="assetType.checklists"
          @input="setChecklists">
          {{ Naming.Checklists }}
          <template #item="{ item }">
            <div>
              <p class="has-text-weight-bold">{{ item.name }}</p>
              <p class="has-text-weight-medium is-size-7 has-text-grey">Frequency: {{ item.frequency }} {{ 'day' | plural(item.frequency) }} • Pass Percentage: {{ item.pass_percentage }}%</p>
            </div>
          </template>
        </data-selector>
      </div>
    </div>
    <template #footer>
      <submit-button :working="working" @submit="store" class="is-success is-rounded" left-icon="check">Create {{Naming.AssetType}}</submit-button>
    </template>
  </base-modal>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {

  data: () => ({
    working: false
  }),

  created() {
    this.$store.dispatch('checklist/loadChecklistList')
    this.$store.dispatch('riskLevel/loadRiskLevelList')
  },

  beforeDestroy() {
    this.clearType()
  },

  methods: {
    ...mapMutations('assetType', [
      'name',
      'setChecklists',
      'code',
      'clearType',
      'risk'
    ]),
    store() {
      this.working = true
      this.$store.dispatch('assetType/store').then(() => {
        this.working = false
        this.$close(false)
        this.$toast.success(this.Convert(this.$lang.assetType.created))
      }).catch(() => {
        this.working = false
        this.$whoops()
      })
    }
  },

  computed: {
    ...mapGetters('assetType', [
      'assetType'
    ]),
    ...mapGetters('checklist', [
      'checklistList'
    ]),
    ...mapGetters('riskLevel', [
      'riskLevelList'
    ])
  }
}
</script>
